var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { dispatchNotificationAction } from './Actions';
import T from '../../Locale';
import Button from '../../Components/ComponentButton';
class ComponentNotificationButton extends Component {
    constructor(props) {
        super(props);
        this.state = { isLoading: false };
        this.onClick = this.onClick.bind(this);
    }
    onClick() {
        return __awaiter(this, void 0, void 0, function* () {
            const { onClick, isAccept } = this.props;
            this.setState({ isLoading: true });
            const success = yield onClick();
            //If it's a shared document, we'll redirect to my-documents
            //Otherwise, if it's accepted we'll always reload it the notification was reloaded
            if (success === 'redirect') {
                window.location.replace('/my-documents');
                return;
            }
            else if (success && isAccept) {
                window.location.reload();
            }
            else if (success) {
                this.setState({ isLoading: false });
            }
        });
    }
    render() {
        const { isLoading } = this.state;
        const { isAccept, actionDone } = this.props;
        let title = isAccept ? T.translate('notifications.accept') : T.translate('notifications.refuse');
        // If the notification has already been responded too,
        // update the title of the button with the action done.
        if (typeof actionDone !== 'undefined' && actionDone === isAccept) {
            title = actionDone ? T.translate('notifications.accepted') : T.translate('notifications.refused');
        }
        return (_jsx(Button, Object.assign({ id: isAccept ? 'accept-notification' : 'refuse-notification', isLoading: isLoading, onClick: this.onClick, isDisabled: actionDone != null }, { children: title })));
    }
}
ComponentNotificationButton.propTypes = {
    actionDone: PropTypes.bool,
    onClick: PropTypes.func.isRequired,
    isAccept: PropTypes.bool
};
const ComponentModalActions = ({ item, onAccept, onRefuse }) => (_jsxs("div", Object.assign({ className: "text-center reveal-notification-controls" }, { children: [!item.action_key || _jsx(ComponentNotificationButton, { actionDone: item.action_done, onClick: onAccept, isAccept: true }), !item.action_key || _jsx(ComponentNotificationButton, { actionDone: item.action_done, onClick: onRefuse, isAccept: false })] })));
ComponentModalActions.propTypes = {
    item: PropTypes.shape({
        id: PropTypes.number.isRequired,
        action_key: PropTypes.string,
        action_done: PropTypes.bool
    }),
    onAccept: PropTypes.func.isRequired,
    onRefuse: PropTypes.func.isRequired
};
const mapDispatchToProps = (dispatch, ownProps) => ({
    onAccept: () => dispatch(dispatchNotificationAction(ownProps.item.id, true)),
    onRefuse: () => dispatch(dispatchNotificationAction(ownProps.item.id, false))
});
export default connect(null, mapDispatchToProps)(ComponentModalActions);
